import type {SerializedStyles} from '@emotion/react';
import type {ImgHTMLAttributes} from 'react';

import {css} from '@emotion/react';
import React from 'react';

const DEFAULT_IMG_SRC = '/static/images/avatar-default.svg';

interface ProfileImgProps extends ImgHTMLAttributes<HTMLImageElement> {
  css?: SerializedStyles;
}

/**
 * ProfileImg renders an image element with customizable attributes and styles.
 * If no `src` is provided, it defaults to a predefined `DEFAULT_IMG_SRC`.
 *
 * @component
 * @param {ProfileImgProps} props - Props for the ProfileImg component.
 * @returns {JSX.Element} The rendered image element.
 */
const ProfileImg = (props: ProfileImgProps) => {
  const {src = DEFAULT_IMG_SRC, css: cssProp, ...rest} = props;
  const imgSrc = src ? src : DEFAULT_IMG_SRC;

  const coverCss = css({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  });

  const mergedImgCss = css([coverCss, cssProp]);

  return (
    <img
      css={mergedImgCss}
      src={imgSrc}
      {...rest}
    />
  );
};

export default ProfileImg;
